/**
 * Extracts a human-readable error reason from an unknown error value.
 *
 * Falls back through `response.data.message`, `err.message`, string coercion,
 * then `'Unknown error'`. The first branch is mostly redundant with
 * `GatewayAxiosClient`'s response interceptor (which copies
 * `response.data.message` onto `err.message`), but kept for non-axios error
 * sources and as a defensive backstop.
 */
export const extractErrorReason = (err: unknown): string => {
  if (typeof err === 'object' && err !== null) {
    const maybeAxios = err as { response?: { data?: { message?: unknown } }; message?: unknown };
    const apiMessage = maybeAxios.response?.data?.message;
    if (typeof apiMessage === 'string' && apiMessage.length > 0) return apiMessage;
    if (typeof maybeAxios.message === 'string' && maybeAxios.message.length > 0) return maybeAxios.message;
  }
  if (typeof err === 'string') return err;
  return 'Unknown error';
};
